<template>
    <div>
		<page v-if="!user_vuex.identifiant":page="(product && product[currentLocale]) ? product[currentLocale].presentation : ''"></page>

		<div v-else>
			<div v-html="intro"></div>

			<data_component 
				@type_data="type_data = $event"
				@columns="columns = $event"
				:column_data="product.column_data"
				:style="size ? 'max-width: ' + (size - 100) + 'px' : ''" 
				:ref="'data'"
			/>

			<div ref="params" v-html="text"></div>

			<br />

			<b-button @click="start">{{ $t('ui.start') }}</b-button>

			<br /><br />

			<p v-show="is_started">{{ $t('ui.result') }}</p>
			<treatment ref="myTreatment"></treatment>

			<div v-if="test_config">
				<hr />
				<b-button @click="get_params('params')">Récupérer les valeurs du formulaire</b-button>
				<br />
				{{ $t('ui.result') }} <br />
				<pre>{{ JSON.stringify(params, null, 2) }}</pre><hr />
			</div>
		</div>
	</div>
</template>

<script>
	import store from "../store";
    import page from "./Page.vue";
    import products from "../services/products.js";
	import viewFile from "../components/viewFile.vue";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";

	var clone = require("clone");
	
	import Vue from 'vue/dist/vue.esm.js';

	const Handlebars = require('handlebars');
	const H = require('just-handlebars-helpers');

	// Register just-handlebars-helpers with handlebars
	H.registerHelpers(Handlebars);

	export default {
		name: "product",
        components: {
            viewFile,
			treatment,
			page
        },
        data: function () {
            return {	
                product: {},
                result: {},
                project_data: {},
                files: {},
                id_treatment: "",
				type_data: 'tabulator',
				columns: [],
				template_intro: "",
				template_text: "",
				intro: "",
				text: "",
				params: {},
				is_started: false,
				user: {}
            }
        },
		watch: {
			$route() {
				this.load(this.$route.params.slug);
			},
			currentLocale()
			{
				console.log("change_lang")

				this.load_lang();
			},
			test_config: {
				deep: true,
                immediate: true,
				handler: function (newVal, oldVal) {
					if (this.test_config)
					{
						this.product = clone(this.test_config)
						this.load_lang();
					}
				}
			},
			type_data: {
				handler: function (newVal, oldVal) {		
					console.log(this.type_data);
					this.load_data();
				}	
			},
			columns: {
				handler: function (newVal, oldVal) {		
					console.log(this.columns);
					this.load_data();
				}	
			},
        },
		props: {
			test: {
				default: false
			},
			test_config: {
				default: () => {}
			},
			size: {
				default: 0
			},
			lang: {
				default: null
			}
		},
		computed: {
			currentLocale()
			{
				return this.$root.$i18n.locale;
			},
            user_vuex: function() {
                return store.getters.getUser;
            },
		},
        methods: {
			get_params(ref) 
			{
				console.log("get_params")
				const container = this.$refs[ref];
				const inputs = container.querySelectorAll('input, select, textarea');
				const values = {};

				inputs.forEach(input => {
					const { name, type } = input;
					if (!name) return; // ignorer les inputs sans name

					if (type === 'checkbox') {
					if (!values[name]) values[name] = [];

					if (input.checked) {
						// si checkbox unique, stocker directement true/false
						const otherCheckboxes = container.querySelectorAll(`input[type="checkbox"][name="${name}"]`);
						if (otherCheckboxes.length === 1) {
						values[name] = true;
						} else {
						values[name].push(input.value);
						}
					} else {
						const otherCheckboxes = container.querySelectorAll(`input[type="checkbox"][name="${name}"]`);
						if (otherCheckboxes.length === 1) {
						values[name] = false;
						}
					}
					} else if (type === 'radio') {
					if (input.checked) {
						values[name] = input.value;
					}
					} else if (input.tagName === 'SELECT') {
						values[name] = input.value;
					} else {
						values[name] = input.value;
					}
				});

				console.log(values)

				this.params = values;
			},
			viewFile: async function (data, name, details, file) {
				this.$refs.view_file.viewFile(data, name, details, file);
				this.id_data_view = data.item.id;
			},
            async load(slug)
            {
                this.product = await products.load_product(slug);

				this.load_lang();
            },
			async load_lang()
			{
				var lang = this.$root.$i18n.locale;
				
				if (this.lang)
					lang = this.lang;

				this.template_intro = Handlebars.compile(this.product[lang].intro);
				this.template_text =  Handlebars.compile(this.product[lang].text);

				this.load_data();
			},
			async load_data()
			{
				this.intro = this.template_intro({ columns: this.columns, type_data: this.type_data, identifiant: this.user_vuex.identifiant || ""});
				this.text = this.template_text({ columns: this.columns, type_data: this.type_data, identifiant: this.user_vuex.identifiant || "" });

				await this.$nextTick();

				this.executeScripts()
				
			},
			executeScripts() {
				const container = this.$refs.params;
				if (!container) return;

				const scripts = container.querySelectorAll('script');

				scripts.forEach((oldScript) => {
					const newScript = document.createElement('script');

					// Copie des attributs (type, src, etc.)
					Array.from(oldScript.attributes).forEach(attr => {
					newScript.setAttribute(attr.name, attr.value);
					});

					// Copie le contenu JS
					newScript.text = oldScript.text;

					// Ajout au DOM pour exécution
					document.body.appendChild(newScript);
					document.body.removeChild(newScript); // Nettoyage
				});
			},
            async getTreatment(all) {
				try {
					if (all)
						this.all = all;

					this.result = await treatments.get(this.id_treatment);

					this.project = this.result.project.libelle;

					if (this.workflow)
						this.$emit("set_description_node", this.workflow, "Projet: " + this.project)

					this.project_data = this.result.project;

					this.date_start = this.result.treatment.dateheure_debut;
					this.date_end = this.result.treatment.dateheure_fin;
					this.status = this.result.treatment.resultat;
					this.details = this.result.treatment.details;
					if (this.status == "na") 
						this.status = null;
					this.user = this.result.user;
					var csv_file = null;

					let jwt = store.state.jwt;

					if (this.all)
					{
						this.fields = [
							{
								key: "name",
								label: "Fichier",
								sortable: true
							},
							{
								key: "type",
								label: "Type",
								sortable: true
							},
							{
								key: "download",
								label: "Téléchargement",
							}
						]
					}

				
				if (this.details_view)
				{
					this.logs = await treatments.getLogs(this.id_treatment);
					this.meters = await treatments.getMeters(this.id_treatment);
				}

				if (this.status || this.details_view) 
				{
					if (this.status)
						clearInterval(this.inter);


					var all_files = await treatments.getFiles(
						this.id_treatment
					);

					console.log("get treatment")
					console.log(all_files.length)
					console.log(this.files.length)

					if (all_files.length == this.files.length)
						return;

					if (this.result.treatment.details && this.result.treatment.details.lines && this.status != "ok" && this.status != "ko")
					{
						var details_lines = JSON.stringify(this.result.treatment.details.lines);
						if (details_lines == this.details_lines)
							return;
						this.details_lines = details_lines;
					}
						
					this.files = [];
					this.files_out = [];

					for (var i = 0; i < all_files.length; i++) {
						if (this.all || all_files[i]["type"] == "export") {
							if (!csv_file && all_files[i]["nom_fichier"].endsWith(".csv")) 
							{
								var res = await treatments.getHeadFile(
									all_files[i].uid
								);
								if (
									res.headers["content-length"] < 2000000
								) {
									csv_file = {
										item: {
											name: all_files[i]["nom_fichier"], id: all_files[i]["uid"],
										},
									};
								}
							}
							this.files.push({
								name: all_files[i]["nom_fichier"],
								details: all_files[i]["details"],
								id: all_files[i]["uid"],
								type: all_files[i].type,
								url: all_files[i].url
							});
							if (all_files[i]["type"] == "export")
							{
								this.files_out.push({
									name: all_files[i]["nom_fichier"],
									url: all_files[i].url,
									id: all_files[i]["uid"],
									type: "url"
								});
							}
						}
					}
					if (csv_file)
					{
						this.viewFile(csv_file, csv_file.item.name, null);
					}

					this.$emit("set_data_in", this.workflow);
				}

				} catch (error) {
					console.log(error);
				}
			},
            async start()
            {
				this.is_started = true;
                var data = await this.$refs.data.save();

                console.log(data)

                var params = this.getFormValues("params")

                console.log(params)

                treatments
					.create(
						this.product.project,
						null,
						data,
						"data.csv",
						[],
                        "import",
                        null,
                        null,
                        params
					)
					.then((res) => {
						//this.$router.push({ name: 'treatment', params: { id: res.treatment.uid } })
						this.treatment_start(
							res.treatment.uid,
							true,
							1000
						);
					})
					.catch((err) => {
						console.log("error : " + err);
						this.$notify({
							group: "info",
							title: err.response.data.msg,
							type: "error",
							duration: -1, // * dure infiniment
							closeOnClick: true,
						});
					});
            },
			treatment_start: function (id, extra = true, time = 5000) {
				
				this.$refs.myTreatment.start(id);
			},

            getFormValues(ref) {
                const container = this.$refs[ref];
                const inputs = container.querySelectorAll('input, select, textarea');
                const values = {};

                inputs.forEach(input => {
                    const { name, type } = input;
                    if (!name) return; // ignorer les inputs sans name

                    if (type === 'checkbox') {
                    if (!values[name]) values[name] = [];

                    if (input.checked) {
                        // si checkbox unique, stocker directement true/false
                        const otherCheckboxes = container.querySelectorAll(`input[type="checkbox"][name="${name}"]`);
                        if (otherCheckboxes.length === 1) {
                        values[name] = true;
                        } else {
                        values[name].push(input.value);
                        }
                    } else {
                        const otherCheckboxes = container.querySelectorAll(`input[type="checkbox"][name="${name}"]`);
                        if (otherCheckboxes.length === 1) {
                        values[name] = false;
                        }
                    }
                    } else if (type === 'radio') {
                    if (input.checked) {
                        values[name] = input.value;
                    }
                    } else if (input.tagName === 'SELECT') {
                        values[name] = input.value;
                    } else {
                        values[name] = input.value;
                    }
                });

                return values
            },
        },
		mounted: async function () {

            console.log(Vue.compile ? '✅ compile dispo' : '❌ compile non dispo');
			if (!this.test)
	            this.load(this.$route.params.slug)
		},
	};
</script>

<style></style>
